import { render, staticRenderFns } from "./DadataSuggestions.vue?vue&type=template&id=60b5d782&scoped=true"
import script from "./DadataSuggestions.vue?vue&type=script&lang=js"
export * from "./DadataSuggestions.vue?vue&type=script&lang=js"
import style0 from "./DadataSuggestions.vue?vue&type=style&index=0&id=60b5d782&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60b5d782",
  null
  
)

export default component.exports